<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Customer Profile
      <div slot="right">
        <router-link
          to="/customers/add"
          style="color: white"
          class="is-small is-info is-action-text"
          v-slot="{ href, navigate }"
          ><b-icon icon="plus" custom-size="default" />
          <b-button
            v-if="isAdmin()"
            type="is-primary"
            :href="href"
            @click="navigate"
          >
            <span class="add-button-right"
              >+ &nbsp;&nbsp;&nbsp; Add New Customer</span
            >
          </b-button>
        </router-link>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <customers-list :checkable="true" />
    </section>
  </div>
</template>

<script>
import CustomersList from "@/components/Customers/CustomersList";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import { Permission } from "../../services/Permissions";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
export default {
  name: "CustomersListView",
  components: { TitleBar, HeroBar, CustomersList },
  mixins: [UserPermissionMixin],
  data() {
    return {
      isModalActive: false,
      id: 100,
      from_dashboard: this.$route.params.from_dashboard,
      url: window.location.href
    };
  },
  methods: {
    addModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    addConfirm() {
      this.isModalActive = false;
      this.$buefy.snackbar.open({
        message: "Confirmed",
        queue: false
      });
    },
    addCancel() {
      this.isModalActive = false;
    },
    isAdmin() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      }
      return false;
    },
    hasPermission() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
      ) {
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "switchCustomerView"
    ]),
    trashObjectName() {
      if (this.trashObject) {
        return this.trashObject.name;
      }

      return null;
    },
    titleStack() {
      return [{ url: "/reportingtracker", name: "Customer Profile" }];
    }
  },
  mounted() {
    if (this.userExternalCheck() || this.switchCustomerView) {
      this.$router.push("/");
    }
  }
};
</script>
